// extracted by mini-css-extract-plugin
export default {"timer":"Style_timer__9vd+4"};